export default __webpack_public_path__ + "static/media/user-gear.d932ccc5.svg";